/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValetingLookUpModel } from '../models/ValetingLookUpModel';
import type { ValetingModel } from '../models/ValetingModel';
import type { ValetingSubmitModel } from '../models/ValetingSubmitModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValetingService {

  /**
   * @param id 
   * @returns ValetingModel Success
   * @throws ApiError
   */
  public static getValeting(
id: number,
): CancelablePromise<ValetingModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/valeting/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postValeting(
requestBody?: ValetingSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/valeting',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @param regNo 
   * @returns ValetingLookUpModel Success
   * @throws ApiError
   */
  public static getValetingLookUp(
soHeaderId?: number,
regNo?: string,
): CancelablePromise<ValetingLookUpModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/valeting/look-up',
      query: {
        'soHeaderId': soHeaderId,
        'regNo': regNo,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

}
